// Module
var code = "<div class=\"js-group-panel {{subclass}}\">\r\n    <div class=\"js-group-panel-left-container\"></div>\r\n    {{#if .showRightContainer}}\r\n    <div class=\"js-group-panel-right-container\"></div>\r\n    {{/if}}\r\n</div>";
// Exports
export default code;